import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class GoogleAD2015Form extends Component {

    validate(setting) {
        let validateTop = ((setting.topADType === 'top_right' && setting.topRightADCode)
            || (setting.topADType === 'top_left' && setting.topLeftADCode)
            || (setting.topADType === 'top_center' && setting.topCenterADCode)
            || (setting.topADType === 'top_none'))

        let validateBottom = ((setting.bottomADType === 'bottom_center' && setting.bottomADCode1)
            || (setting.bottomADType === 'bottom_double' && setting.bottomADCode2 && setting.bottomADCode3)
            || (setting.bottomADType === 'bottom_none'))

        let empty = (setting.topADType === 'top_none') && (setting.bottomADType === 'bottom_none');

        return !empty && validateTop && validateBottom
    }

    componentDidMount() {
        const { onChange } = this.props
        let setting = Object.assign({},  this.props.data.setting, {
            topADType: this.props.data.setting.topADType?this.props.data.setting.topADType:'top_none',
            bottomADType: this.props.data.setting.bottomADType?this.props.data.setting.bottomADType:'bottom_none',
        });

        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleTopADTypeChange(ADType) {
        const { onChange } = this.props
        let setting = Object.assign({},  this.props.data.setting, {
            topADType: ADType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleBottomADTypeChange(ADType) {
        const { onChange } = this.props
        let setting = Object.assign({},  this.props.data.setting, {
            bottomADType: ADType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props
        var newObject = Object();
        newObject[type] = ADCode;
        let setting = Object.assign({},  this.props.data.setting, newObject);
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
        <div className="desc_plugin7">
            <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
            <div className="info_pluginline">
                <strong className="tit_set">설정 방법</strong>
                <ol className="list_plugin">
                    <li>
                        <span className="txt_em">1</span>
                        광고 배치 유형 중에 1 가지를 선택해주세요. (상단/하단 각 1개씩 선택 가능)
                    </li>
                    <li>
                        <span className="txt_em">2</span>
                        광고 코드 입력창에 애드센스 광고 코드를 넣어주세요.
                        <a href="https://www.google.com/adsense/app?hl=ko" target="_blank" className="link_other">애드센스 바로가기</a>
                    </li>
                    <li>
                        <span className="txt_em">3</span>
                        적용 버튼을 누르면 설정이 완료됩니다.
                    </li>
                </ol>
            </div>
            <fieldset>
                <legend className="tit_set">상단 광고</legend>
                <div className="list_google">
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.topADType == "top_right"} onChange={(e)=>this.handleTopADTypeChange('top_right')}/>
                        <span className="ico_google">상단 우측</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.topADType == "top_left"} onChange={(e)=>this.handleTopADTypeChange('top_left')}/>
                        <span className="ico_google ico_google2">상단 좌측</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.topADType == "top_center"} onChange={(e)=>this.handleTopADTypeChange('top_center')}/>
                        <span className="ico_google ico_google3">상단 전체</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin1" className="inp_set" checked={data.setting.topADType == "top_none"} onChange={(e)=>this.handleTopADTypeChange('top_none')}/>
                        <span className="ico_google ico_google4">광고 없음</span>
                    </label>
                </div>
                {data.setting.topADType == "top_right" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="336x280(권장), 300x250(권장), 250x250, 200x200 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('topRightADCode', e.target.value)}>{data.setting.topRightADCode}</textarea>
                )}
                {data.setting.topADType == "top_left" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="336x280(권장), 300x250(권장), 250x250, 200x200 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('topLeftADCode', e.target.value)}>{data.setting.topLeftADCode}</textarea>
                )}
                {data.setting.topADType == "top_center" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="728x90(권장) 또는 468x60 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('topCenterADCode', e.target.value)}>{data.setting.topCenterADCode}</textarea>
                )}
            </fieldset>
            <fieldset>
                <legend className="tit_set">하단 광고</legend>
                <div className="list_google">
                    <label className="lab_google">
                        <input type="radio" name="plugin2" className="inp_set" checked={data.setting.bottomADType == "bottom_center"} onChange={(e)=>this.handleBottomADTypeChange('bottom_center')}/>
                        <span className="ico_google ico_google5">하단 전체</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin2" className="inp_set" checked={data.setting.bottomADType == "bottom_double"}  onChange={(e)=>this.handleBottomADTypeChange('bottom_double')}/>
                        <span className="ico_google ico_google6">하단 좌측, 우측</span>
                    </label>
                    <label className="lab_google">
                        <input type="radio" name="plugin2" className="inp_set" checked={data.setting.bottomADType == "bottom_none"} onChange={(e)=>this.handleBottomADTypeChange('bottom_none')}/>
                        <span className="ico_google ico_google7">광고 없음</span>
                    </label>
                </div>
                {data.setting.bottomADType == "bottom_center" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="728x90(권장), 468x60, 336x280(권장), 300x250(권장), 250x250, 200x200 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('bottomADCode1', e.target.value)}>{data.setting.bottomADCode1}</textarea>
                )}
                {data.setting.bottomADType == "bottom_double" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="336x280(권장), 300x250(권장), 250x250, 200x200 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('bottomADCode2', e.target.value)}>{data.setting.bottomADCode2}</textarea>
                )}
                {data.setting.bottomADType == "bottom_double" && (
                    <textarea className="tf_blog" title="광고 코드 입력" placeholder="336x280(권장), 300x250(권장), 250x250, 200x200 크기의 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('bottomADCode3', e.target.value)}>{data.setting.bottomADCode3}</textarea>
                )}
            </fieldset>
            {this.props.saveButton()}
        </div>
        )
    }
}

GoogleAD2015Form.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default GoogleAD2015Form
